import { InsuranceType } from '@/pages/members/constants/insurance';
import InsuranceProviderSelectionStep from '@/pages/members/pages/Onboarding/steps/InsuranceProviderSelectionStep';
import RedirectingStep from '@/pages/members/pages/Onboarding/steps/RedirectingStep';

import { OnboardingNodeType, OnboardingStepType } from '../../steps/types';
import { OnboardingNode } from '../../types';

export const INSURANCE_PROVIDER_NODE: OnboardingNode = {
  index: 0,
  key: OnboardingNodeType.INSURANCE_PROVIDER,
  options: { countsTowardProgressBar: false },
  elements: [
    {
      condition: [
        {
          step: OnboardingNodeType.INSURANCE_TYPE,
          field: 'insuranceType',
          value: InsuranceType.NO_INSURANCE
        }
      ],
      uid: OnboardingStepType.INSURANCE_PROVIDER,
      component: (
        <RedirectingStep
          redirectToNodeType={OnboardingNodeType.PRIMARY_SUBSTANCE}
          uid={OnboardingStepType.INSURANCE_PROVIDER}
          nodeType={OnboardingNodeType.INSURANCE_PROVIDER}
          displayName=""
          actionButtonText="Next"
        />
      )
    },
    {
      uid: OnboardingStepType.INSURANCE_PROVIDER,
      component: (
        <InsuranceProviderSelectionStep
          uid={OnboardingStepType.INSURANCE_PROVIDER}
          nodeType={OnboardingNodeType.INSURANCE_PROVIDER}
          displayName="Location & Insurance Provider"
          actionButtonText="Next"
          showAllContent={true}
        />
      )
    }
  ]
};
